import { useContext } from 'react';
import { DeviceContext } from 'utils/Device/DeviceContext';

export default function TableViewStyles() {
    const device = useContext(DeviceContext);

    return {
        Container: {
            position: "relative",
            marginTop: device.isMobile ? "1.5em" : "3em",
            overflowX: "auto", // Ensures horizontal scrolling
            WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS devices
            msOverflowStyle: "scrollbar", // Ensures scrollbar visibility in Windows browsers
            maxHeight: "400px"
        },
        TableSX: {
            width: '100%', // Set the width of the table to 100%
            minWidth: "380px", // Ensures a minimum width for larger screens
            tableLayout: "auto"
        },
        FixedColumn: {
            position: "sticky",
            top: "0",
            left: "0",
            zIndex: "20",
            backgroundColor: "#fafafa"
        },
        Header: {

        },
        Body: {
            whiteSpace: 'pre-line'
        },
        Footer: {
            fontWeight: "800"
        }
    };
};
